





































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
@Component({
  name: "uploadAddon",
  components: {
    PicUpload,
  },
})
export default class UploadAddon extends Vue {
  private zItem!: any;
  private answer: any = [];
  private previewSrcList: any = [];
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  @Prop({ type: Object, default: {} })
  item!: any;

  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.map((as: any) => {
          return {
            url: as,
            isImage: this.testIsImage(as),
            fileName: this.getfileName(as),
          };
        });
        this.previewSrcList = value.answer.map((as: any) => {
          return as;
        });
      }
    }
  }

  testIsImage(url: string) {
    let imgs = ["png", "jpg", "jpeg", "webp"];
    return imgs.some((ment) => {
      return url.indexOf(ment) >= 0;
    });
  }
  getfileName(url: string) {
    let splits = url.split("/");
    return decodeURIComponent(splits[splits.length - 1]);
  }
  openImage(url: string) {
    window.open(url);
  }
}
